import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef  } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';
import { TblHeadCellDef, UITblGroup, AggregateType, UiTblSubSOBrkPSLevel } from '../../shared/ui-classes';
import { GenService } from '../../shared/gen-ser.service';
import { SalesOrder, UiTblSubSO, UiSoOrder, Equipment, PartialDelivery, configDefs, FileElement, BreakerPS, SSOStatus, SOStatus } from '../../shared/misc-classes';
import { SubSalesOrder } from '../../shared/misc-classes';
import { SubSOUIPipePipe } from '../../filters/sub-souipipe.pipe';
import { SubEqupUIPipePipe } from '../../filters/sub-equiplevpipe.pipe';

@Component({
  selector: 'app-mast-plan',
  templateUrl: './mast-plan.component.html',
  styleUrls: ['./mast-plan.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MastPlanComponent implements OnInit {

  headRows: Array<TblHeadCellDef> = [];
  filteredHeadRows: Array<TblHeadCellDef> = [];
  _filterPipe: SubEqupUIPipePipe = new SubEqupUIPipePipe();
  _breakerPSUIObjList: Array<UiTblSubSOBrkPSLevel>;
  _filteredSubSoUIObjList: Array<UiTblSubSOBrkPSLevel>;
  _rowSpanArr:any = {};
  search: string = '';
  tblModStatus: showTblModule = new showTblModule();
  isFullScreenTbl: boolean = false;

  isLoading:boolean = false;


  // filteredSaleOrderCount:number = 0;
  // filteredSubOrderCount:number = 0;


  constructor(private _dataService: DataService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    
    this._dataService.currPageName = 'Master Plan Live';
    this.headRows = this.initTableHeaders();
    this.arrangeHeadColumns();
    this.isLoading = true;
    this.cd.markForCheck();
    this._dataService.getDataDefinitions().subscribe(res => {
      this.loadData();
    });
  }
  loadData(): void {
    this.isLoading = true;
    this._dataService.getAllSalesOrder(1).subscribe((saleOrders) => {      
      let _tmpSubSoUIObjList: Array<UiTblSubSOBrkPSLevel> = [];

      let _tmpFirstSOObj: UiTblSubSOBrkPSLevel;
      let _tmpFirstSubSOObj: UiTblSubSOBrkPSLevel;
      let _tmpFirstEquipmentObj: UiTblSubSOBrkPSLevel;
      // if(saleOrders)

      saleOrders.forEach((saleOrder) => {
        let isFirstRowInSO: boolean = true;

        saleOrder.subSalesOrder.forEach((subSO) => {
          //if(subSO.parentSORef.marketingIP.salesOrderNo == "4000000000" && subSO.subOrderNoId == "03"){
          if(subSO.isSSOStatusSet(SSOStatus.Dispatched) != true){

          let isFirstRowInSubOrder: boolean = true;

          subSO.pmTechSubSalesOrder.equipmentList.forEach((equipment) => {


            let isFirstRowInEquipment: boolean = true;

            if(this.isVSCQtyEnabled(subSO.pmTechSubSalesOrder.productVarient,equipment.equipmentType,equipment.breakerType) == true){
                equipment.breakerPSList.forEach((brkrPS) => {
            
                  let _tmpObj = new UiTblSubSOBrkPSLevel(subSO, equipment, brkrPS, isFirstRowInSO, isFirstRowInSubOrder,isFirstRowInEquipment);
                  _tmpObj.soId = saleOrder.salesOrderId;
                  _tmpSubSoUIObjList.push(_tmpObj);

                  if (isFirstRowInSO) {
                    _tmpFirstSOObj = _tmpObj;
                  }
                  if (isFirstRowInSubOrder) {
                    _tmpFirstSubSOObj = _tmpObj;
                  }
                  if (isFirstRowInEquipment) {
                    _tmpFirstEquipmentObj = _tmpObj;
                  }

                _tmpFirstSOObj.totalBreakerPsCountForSo++;
                _tmpFirstSubSOObj.totalBreakerPsCountForSubSo++;
                _tmpFirstEquipmentObj.totalBreakerPsCountForEquip++;
                

                isFirstRowInSubOrder = false;
                isFirstRowInSO = false;
                isFirstRowInEquipment = false;

                });
            }
            else{equipment.breakerPSList.forEach((brkrPS) => {
              let _tmpObj = new UiTblSubSOBrkPSLevel(subSO, equipment, brkrPS, isFirstRowInSO, isFirstRowInSubOrder,isFirstRowInEquipment);
                _tmpObj.soId = saleOrder.salesOrderId;
              _tmpSubSoUIObjList.push(_tmpObj);

              if (isFirstRowInSO) {
                _tmpFirstSOObj = _tmpObj;
              }
              if (isFirstRowInSubOrder) {
                _tmpFirstSubSOObj = _tmpObj;
              }
              if (isFirstRowInEquipment) {
                _tmpFirstEquipmentObj = _tmpObj;
              }

            _tmpFirstSOObj.totalBreakerPsCountForSo++;
            _tmpFirstSubSOObj.totalBreakerPsCountForSubSo++;
            _tmpFirstEquipmentObj.totalBreakerPsCountForEquip++;

            isFirstRowInSubOrder = false;
            isFirstRowInSO = false;
            isFirstRowInEquipment = false;
            });
          
            }
          
            
          });
          //console.log("subSO::",subSO);
        }
        });              
      })

      //init the required ui name
      _tmpSubSoUIObjList.forEach((_subsoUIObj) => {
        this.prepareSSOUIObjData(_subsoUIObj)
      });
      this._breakerPSUIObjList = _tmpSubSoUIObjList;

      this.filterRows();
      this.isLoading = false;
    });
  }
  isVSCQtyEnabled(_variantId: string, _equipTypeId : string, _brkrTypeID){
    if(this.isSpecifiedEquipType(_equipTypeId) == false) return false; 
    return this._dataService.isVSCQtyEnable(_variantId, _equipTypeId,_brkrTypeID);
   }
   isSpecifiedEquipType(_equipTypeId:string){
    if(_equipTypeId == null || _equipTypeId == ''){
      return false;
    } 
    return !this._dataService.isGeneralEquipmentType(_equipTypeId);
  }
  prepareSSOUIObjData(_subsoUIObj: UiTblSubSOBrkPSLevel): any {
    _subsoUIObj.plantName = this._dataService.getPlantName(_subsoUIObj.sso.parentSORef.marketingIP.plantId);
    _subsoUIObj.customerName = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.customerName);
    _subsoUIObj.projectName = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.projectName);
    _subsoUIObj.salesOrderNo = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.salesOrderNo);
    _subsoUIObj.salesOrderNoNew = this.strFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.salesOrderNoNew);
    _subsoUIObj.subSalesOrderNo = this.strFrmt(_subsoUIObj.sso.subOrderNoId);
    _subsoUIObj.rowHeader = _subsoUIObj.salesOrderNo + '\n' + _subsoUIObj.customerName;
    _subsoUIObj.boardname = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.boardname); //Board Name     
    _subsoUIObj.plannedManfMonth = this.monthFrmt(_subsoUIObj.sso.planningIP.plannedManufacturingMonth);
    _subsoUIObj.invoicingmonth = this.monthFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.invoicingmonth);
    _subsoUIObj.plannedRevenueMonth = this.monthFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedRevnueMonth);
    _subsoUIObj.rotddate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.rotddate);  
    _subsoUIObj.manfStrategy = this._dataService.getManufacturingStrategyName(_subsoUIObj.sso.planningIP.manufacturingStrategy);
    _subsoUIObj.plndLineLoadingDate = this.dtFrmt(_subsoUIObj.sso.planningIP.plannedLineLoadingDate);
    _subsoUIObj.reqLineLoadingDate = this.dtFrmt(_subsoUIObj.sso.planningIP.requestedLineLoadingDate);
    _subsoUIObj.actLineLoadingDate = this.dtFrmt(_subsoUIObj.sso.productionIP.lineLoadingActualDate);
    _subsoUIObj.customerPoValue = this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.customerPoValue);
    _subsoUIObj.marketingEngineer = this._dataService.getMarketingEngineerName(_subsoUIObj.sso.parentSORef.marketingIP.marketingEngineerId);
    _subsoUIObj.projectManager = this._dataService.getProjectManagerName(_subsoUIObj.sso.parentSORef.marketingIP.projectManagerId);
    _subsoUIObj.projectEngineer = this._dataService.getProjectEngineerName(_subsoUIObj.sso.parentSORef.pmCommercial.projectEngineerId);
    _subsoUIObj.elecDesignEngineer = this._dataService.getElecDesignEngineerName(_subsoUIObj.sso.enggDrawIP.electricalDesignEngineerId);
    _subsoUIObj.mechDesignEngineer = this._dataService.getMechDesignEngineerName(_subsoUIObj.sso.enggDrawIP.mechanicalDesignEngineerId);
    _subsoUIObj.salesChannelName = this._dataService.getsaleChannelName(_subsoUIObj.sso.parentSORef.marketingIP.saleChannelId);
    _subsoUIObj.regionName = this._dataService.getRegionName(_subsoUIObj.sso.parentSORef.marketingIP.regionId);
    _subsoUIObj.poDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.purchaseOrderDate);
    _subsoUIObj.clearPODate = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.clearPoReceiptDate);
    _subsoUIObj.consultantName = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.consultantName);
    _subsoUIObj.warrantyMonths = this._dataService.getWarrantyMonths(_subsoUIObj.sso.parentSORef.marketingIP.warrantyMonthId);
    _subsoUIObj.specialPoint = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.specialPoint.splPointText);
    _subsoUIObj.specialPointFiles = _subsoUIObj.sso.parentSORef.marketingIP.specialPoint.FileArray;
    _subsoUIObj.ordertypeName = this._dataService.getOrderTypeName(_subsoUIObj.sso.parentSORef.marketingIP.ordertypeId);
    
    
    _subsoUIObj.contractDeliveryFirm = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.marketingIP.contractDeliveryDateFirm);
    _subsoUIObj.contractDeliveryWeeks = this.convNumToStr(_subsoUIObj.sso.parentSORef.marketingIP.contractDeliveryDateInWeek);
    _subsoUIObj.contractDeliveryDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.contractDeliveryDate);
    _subsoUIObj.ldApplicability = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.marketingIP.ldApplicabilityId);
    _subsoUIObj.ldPercentage = this._dataService.getLDPercentName(_subsoUIObj.sso.parentSORef.marketingIP.ldPercent);
    _subsoUIObj.ldCap = this._dataService.getLDCapName(_subsoUIObj.sso.parentSORef.marketingIP.ldCap + '');
    _subsoUIObj.deliveryTerm = this._dataService.getDeliveryTermName(_subsoUIObj.sso.parentSORef.marketingIP.deliveryTerm)
    _subsoUIObj.placeOfDelivery = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.placeOfDelivery);
    _subsoUIObj.daysgoodsReach = this.convNumToStr(_subsoUIObj.sso.pmTechSubSalesOrder.DaysgoodsReach);
    // if(_subsoUIObj.sso.parentSORef.marketingIP.salesOrderNo == "4201849993"){
    //   console.log(_subsoUIObj.sso.pmTechSubSalesOrder.DaysgoodsReach, "days")
    // }
   
    _subsoUIObj.deliveryFromAbb = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.tentativeDeliveryDate);
    _subsoUIObj.paymentTerm = this._dataService.getPaymentTermName(_subsoUIObj.sso.parentSORef.marketingIP.paymentTermId);
    _subsoUIObj.paymentDays = this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.paymentDaysNo);
    _subsoUIObj.FCMMatCost =this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.fcmMatCost);
    _subsoUIObj.JSRMatCost = this.frmtNumStr(_subsoUIObj.sso.pmTechSubSalesOrder.jsrMatCost);
    _subsoUIObj.JSRGM = this.frmtNumStr(_subsoUIObj.sso.pmTechSubSalesOrder.jsrGm);
   
    _subsoUIObj.JSRNM = this.frmtNumStr(_subsoUIObj.sso.pmTechSubSalesOrder.jsrNm);
    _subsoUIObj.FCMGM = this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.fcmGm);
    // _subsoUIObj.JSRGM = this.frmtNumStr(_subsoUIObj.sso.parentSORef.pmCommercial.jsrGm);
    _subsoUIObj.FCMNM = this.frmtNumStr(_subsoUIObj.sso.parentSORef.marketingIP.fcmNm);
    // _subsoUIObj.JSRNM = this.frmtNumStr(_subsoUIObj.sso.parentSORef.pmCommercial.jsrNm);
    _subsoUIObj.AdvPmtCondition = this._dataService.getAdvPayConditionName(_subsoUIObj.sso.parentSORef.marketingIP.advPaymentConditionId);
    _subsoUIObj.AdvPmt = this._dataService.getAdvPayPercentName(_subsoUIObj.sso.parentSORef.marketingIP.advPaymentId);
    _subsoUIObj.AdvPmtMilestone = this._dataService.getAdvPayAcgABGMilestoneName(_subsoUIObj.sso.parentSORef.marketingIP.advPaymentMilestoneId);
    _subsoUIObj.PBGPayCondition = this._dataService.getPBGPayConditionName(_subsoUIObj.sso.parentSORef.marketingIP.pbgPaymentConditionId);
    _subsoUIObj.CPBGPayCondition = this._dataService.getCPBGPayConditionName(_subsoUIObj.sso.parentSORef.marketingIP.cpbgPaymentConditionId);

    _subsoUIObj.SOCreationPlanned = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soCreationDatePlanned);
    _subsoUIObj.SOCreationActual = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soCreationDateActual);
    _subsoUIObj.SOCreationRemarks = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soCreationActualToken.addNotes);

    _subsoUIObj.SOReleasePlanned = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soReleaseDatePlanned);
    _subsoUIObj.SOReleaseActual = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soReleaseDateActual);
    _subsoUIObj.SOReleaseRemarks = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.soReleaseActualToken.addNotes);

    _subsoUIObj.OrderHandOverPlanned = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.plannedOverHandingDate);
    _subsoUIObj.OrderHandOverActual = this.dtFrmt(_subsoUIObj.sso.parentSORef.marketingIP.actualHandingOverDate);
    _subsoUIObj.OrderHandOverRemarks = this.strFrmt(_subsoUIObj.sso.parentSORef.marketingIP.actualHandingOverToken.addNotes);

    _subsoUIObj.ABGACGSubmissionDetails = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgSubmissionDetails)
    _subsoUIObj.abgOrAcgPlndCollDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgPlndCollDate)
    _subsoUIObj.ABGACGSubmissionPlannedDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgPlndSubDate);
    _subsoUIObj.ABGACGActSubmissDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgActSubDate);
    _subsoUIObj.ABGACGActCollectDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.abgOrAcgActCollDate);

    _subsoUIObj.PBGSubmissionDetails = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.pmCommercial.pbgSubmissionDetails)
    _subsoUIObj.pbgPlndSubDate= this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.pbgPlndSubDate);
    _subsoUIObj.pbgReqSubDate= this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.pbgReqSubDate);
    _subsoUIObj.PBGActSubmissDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.pbgActSubDate);
    _subsoUIObj.PBGActCollectDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.pbgActCollDate);

    _subsoUIObj.CPBGSubmissionDetails = this._dataService.getYesNoDispName(_subsoUIObj.sso.parentSORef.pmCommercial.cpbgSubmissionDetails)
    _subsoUIObj.CPBGActSubmissDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.cpbgActSubDate);
    _subsoUIObj.CPBGActCollectDate = this.dtFrmt(_subsoUIObj.sso.parentSORef.pmCommercial.cpbgActCollDate);

    _subsoUIObj.variantOfProduct = this._dataService.getProductVariantName(_subsoUIObj.sso.pmTechSubSalesOrder.productVarient);
    _subsoUIObj.noOfPanels = this._dataService.getPanelNumName(_subsoUIObj.sso.pmTechSubSalesOrder.numberOfPanels);
    _subsoUIObj.complexityOfJobs = this._dataService.getJobComplexityName(_subsoUIObj.sso.pmTechSubSalesOrder.jobComplexity);
    _subsoUIObj.noOfFeedertypes = this._dataService.getFeederTypeName(_subsoUIObj.sso.pmTechSubSalesOrder.FeederOrLocationTypeNo);

    _subsoUIObj.plannedSLDSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedSldSubmissionDate);
    _subsoUIObj.initialSLDSubmissActualDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.initialSLDSubmissionDateActual);
    _subsoUIObj.remarkForSLDSubmission = this.strFrmt(_subsoUIObj.sso.enggDrawIP.initialSLDSubmissionActualDateToken.addNotes);

    _subsoUIObj.plannedGAFDrawSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate);
    _subsoUIObj.actualGAFDrawSubmissDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.initialGAFDSubmissionDateActual);
    _subsoUIObj.remarkForGAFSubmissActualDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.initialGAFDSubmissionActualDateToken.addNotes)

    _subsoUIObj.plannedSchBOMSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedSchematicDrawingDate);
    _subsoUIObj.actualSchBOMSubmisDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.initialSchematicDBOMSubmissionDateActual);
    _subsoUIObj.remarkSchBOMSubmissDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.initialSchematicDBOMSubmissionActualDateToken.addNotes);

    _subsoUIObj.plannedBusBarSizingCalcSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedSizingCalSubmissionDate);
    _subsoUIObj.actualBusBarSizingCalcSubmissDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.initialGTPCTPTBBSizingCalcSubmissionDateActual);
    _subsoUIObj.remarkBusBarSizingCalcSubmissDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.initialGTPCTPTBBSizingCalcSubmissionActualDateToken.addNotes);

    _subsoUIObj.finalDrawingSubmissDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.finalDrawingSubmissionDateActual);
    _subsoUIObj.insulationLevelKV = this._dataService.getInsulationKVName(_subsoUIObj.sso.pmTechSubSalesOrder.insulationLevel);

    var _equipments = this.getEquipType(_subsoUIObj.equipment, _subsoUIObj.breaker);
    _subsoUIObj.typeOfEquipment = _equipments.equipType;
    _subsoUIObj.typeOfBreaker = _equipments.breakerType;
    _subsoUIObj.qtyOfPanel = _equipments.qtyOfPanel;
    _subsoUIObj.contractualValue = _equipments.contractualvalue;
    _subsoUIObj.qtyOfVSC = _equipments.VSCQuantity;
    _subsoUIObj.totalqtyOfBreaker = _equipments.totalqtyOfBreaker;
    _subsoUIObj.breakerPS = _equipments.breakerPS
    _subsoUIObj.qtyOfBreaker = _equipments.qtyOfBreaker
    _subsoUIObj.importedEarthingSwitchApplicability = _equipments.importedSwitch;
    _subsoUIObj.kioskApplic = this._dataService.getKioskApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.kioskApplicable);
    _subsoUIObj.tempRiseTestApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.tempRaiseTestApplicability);
    _subsoUIObj.impBrkApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.breakerApplicability);
    _subsoUIObj.impVSCApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.vscApplicability);
    _subsoUIObj.spareApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.spareApplicability);
    _subsoUIObj.etApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.etApplicability);
    _subsoUIObj.geRelayApplic = this._dataService.getApplicabilityOptionName(_subsoUIObj.sso.pmTechSubSalesOrder.geRelayApplicability);

    _subsoUIObj.busbarMaterial = this._dataService.getBusbarMatrialName(_subsoUIObj.sso.pmTechSubSalesOrder.busbarMaterial);
    _subsoUIObj.busbarSleeve = this._dataService.getBusbarSleeveName(_subsoUIObj.sso.pmTechSubSalesOrder.busbarSleeve);
    for(var i = 0; i < _subsoUIObj.sso.pmTechSubSalesOrder.commentsDateList.length; i++ ){
      _subsoUIObj.cmntOnActualSubmissDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.commentsDateList[i].commentRcvdOnSubActDate);
      _subsoUIObj.cmntOnActualComplainceDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.commentsDateList[i].complainceAgnstCommentActDate);
    }
    _subsoUIObj.plannedDrawingAprvlDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedDrawingApprovalDate);
    _subsoUIObj.actualDrawingAprvlDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualDrawingApprovalDate);
    _subsoUIObj.remarkDrawingAprvlDate = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualDrawingApprovalToken.addNotes);
    _subsoUIObj.plannedCTFinalEnggToPMDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMPlannedDate);
    _subsoUIObj.actualCtFinalEnggToPMDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate);
    _subsoUIObj.remarkCtFinalEnggToPMDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMActualToken.addNotes);

    _subsoUIObj.plannedSpecialMatPricePmtoSCm = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.splMatPriceFinalizationPlannedDate);
    _subsoUIObj.actualSpecialMatPricePmtoSCm = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.splMatFinalizationActualDate);
    _subsoUIObj.remarkSpecialMatPricePmtoSCm = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.splMatFinalizationActualDateToken.addNotes);


    _subsoUIObj.plannedCTFinalPMtoSCMDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedCtFinalizationDate);
    _subsoUIObj.actualCTFinalPMtoSCMDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualCtFinalizationDate);
    _subsoUIObj.remarkCTFinalPMtoSCMDate = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualCtFinalizationToken.addNotes);

    _subsoUIObj.plannedSpecialPriceGvnbyENGGtoPM = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMPlannedDate);
    _subsoUIObj.actualSpecialPriceGvnbyENGGtoPM = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate);
    _subsoUIObj.remarkSpecialPriceGvnbyENGGtoPM = this.strFrmt(_subsoUIObj.sso.enggDrawIP.ctFinalizationGivenByEnggToPMActualToken.addNotes);
   

    _subsoUIObj.plannedCTFinalfromSCMDate = this.dtFrmt(_subsoUIObj.sso.scmIP.ctFinalizationFromSCMPlannedDate);
    _subsoUIObj.actualCTFinalfromSCMDate = this.dtFrmt(_subsoUIObj.sso.scmIP.ctFinalizationFromSCMActualDate);
    _subsoUIObj.remarkCTFinalfromSCMDate = this.strFrmt(_subsoUIObj.sso.scmIP.ctFinalizationFromSCMActualToken.addNotes);

    _subsoUIObj.plannedSpecialMatPricefromSCMDate = this.dtFrmt(_subsoUIObj.sso.scmIP.splMatFGivenbySCMtoEnggPlannedDate);
    _subsoUIObj.actualSpecialMatPricefromSCMDate = this.dtFrmt(_subsoUIObj.sso.scmIP.splMatFGivenbySCMtoEnggActualDate);
    _subsoUIObj.remarkSpecialMatPricefromSCMDate = this.strFrmt(_subsoUIObj.sso.scmIP.splMatFGvnbySCMtoEnggActualToken.addNotes);
    
    _subsoUIObj.plannedPackingDispatchClrDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.plannedPackingDisptachClearanceDate);
    _subsoUIObj.requestedPackingDispatchClrDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.requestPackingDate);
    _subsoUIObj.actualPackingDispatchClrDate = this.dtFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualPackingDate);
    _subsoUIObj.remarkPackingDispatchClrDate = this.strFrmt(_subsoUIObj.sso.pmTechSubSalesOrder.actualPackingToken.addNotes);
    _subsoUIObj.plannedSLDApprovalDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.plannedSLDGAApprovalDate);
    _subsoUIObj.actualSLDApprovalDate = this.dtFrmt(_subsoUIObj.sso.enggDrawIP.actualSLDGAApprovalDate);
    _subsoUIObj.remarkSLDApprovalDate = this.strFrmt(_subsoUIObj.sso.enggDrawIP.actualSLDGAApprovalToken.addNotes);
    _subsoUIObj.plannedC40Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.plannedC40Date);
    _subsoUIObj.actualC40Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC40Date);
    _subsoUIObj.remarkC40Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC40Token.addNotes);
    _subsoUIObj.plannedC50Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.plannedC50Date);
    _subsoUIObj.actualC50Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC50Date);
    _subsoUIObj.remarkC50Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC50Token.addNotes);
    _subsoUIObj.plannedC60Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.plannedC60Date);
    _subsoUIObj.actualC60Date = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualC60Date);
    _subsoUIObj.remarkC60Date = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualC60Token.addNotes);
    _subsoUIObj.plannedLongLeadDate = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.plannedLongLeadReleaseDate);
    _subsoUIObj.actualLongLeadDate = this.dtFrmt(_subsoUIObj.sso.enggProcureIP.actualLongLeadReleaseDate);
    _subsoUIObj.remarkLongLeadDate = this.strFrmt(_subsoUIObj.sso.enggProcureIP.actualLongLeadReleaseToken.addNotes);
    _subsoUIObj.plannedImpBrkrPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.importedBreakerPOReleasedPlannedDate);
    _subsoUIObj.actualImpBrkrPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.importedBreakerPOReleasedActualDate);
    _subsoUIObj.remarkImpBrkrPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.importedBreakerPOReleasedActualToken.addNotes);

    _subsoUIObj.plannedImpVscPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.importedVSCPOReleasedPlannedDate);
    _subsoUIObj.actualImpVscPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.importedVSCPOReleasedActualDate);
    _subsoUIObj.remarkImpVscPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.importedVSCPOReleasedActualToken.addNotes);
    _subsoUIObj.plannedGERelayPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.geRelayPOReleasePlannedDate);
    _subsoUIObj.actualGERelayPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.geRelayPOReleaseActualDate);
    _subsoUIObj.remarkGERelayPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.geRelayPOReleaseActualToken.addNotes);
    _subsoUIObj.plannedCTPTPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.ctPTPOReleasedPlannedDate);
    _subsoUIObj.actualCTPTPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.ctPTPOReleasedActualDate);
    _subsoUIObj.remarkCTPTPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.ctPTPOReleasedActualToken.addNotes);
    _subsoUIObj.plannedRelayPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.relayPOReleasedPlannedDate);
    _subsoUIObj.actualRelayPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.relayPOReleasedActualDate);
    _subsoUIObj.remarkRelayPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.relayPOReleasedActualToken.addNotes);
    _subsoUIObj.plannedBreakerPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.breakerPOReleasePlannedDate);
    _subsoUIObj.actualBreakerPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.breakerPOReleaseActualDate);
    _subsoUIObj.remarkBreakerPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.breakerPOReleaseActualToken.addNotes);
    _subsoUIObj.plannedSAPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.saPOReleasedPlannedDate);
    _subsoUIObj.actualSAPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.saPOReleasedActualDate);
    _subsoUIObj.remarkSAPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.saPOReleasedActualToken.addNotes);
    _subsoUIObj.plannedMeteringBoxPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.meteringBoxPOReleasePlannedDate);
    _subsoUIObj.actualMeteringBoxPORlsDate = this.dtFrmt(_subsoUIObj.sso.purchasePOIP.meteringBoxPOReleaseActualDate);
    _subsoUIObj.remarkMeteringBoxPORlsDate = this.strFrmt(_subsoUIObj.sso.purchasePOIP.meteringBoxPOReleaseActualToken.addNotes);
    _subsoUIObj.plannedPickListtoStoresDate = this.dtFrmt(_subsoUIObj.sso.planningIP.plannedPickListIssueToStoreDate);
    _subsoUIObj.requestedPickListtoStoresDate = this.dtFrmt(_subsoUIObj.sso.planningIP.requestedPickListIssueToStoreDate);
    _subsoUIObj.actualPickListtoStoresDate = this.dtFrmt(_subsoUIObj.sso.planningIP.actualPickListIssueToStoreDate);
    _subsoUIObj.remarkPickListtoStoresDate = this.strFrmt(_subsoUIObj.sso.planningIP.actualPickListIssueToStoreToken.addNotes);

    _subsoUIObj.plannedImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerPlannedReceiptDate);
    _subsoUIObj.requestedImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerRequestedReceiptDate);
    _subsoUIObj.supplierImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerSupplierCommittedDate);
    _subsoUIObj.actualImpBrkrRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerActualReceiptDate);
    _subsoUIObj.remarkImpBrkrRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedBreakerActualReceiptToken.addNotes);
    _subsoUIObj.plannedImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCPlannedReceiptDate);
    _subsoUIObj.requestedImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCRequestedReceiptDate);
    _subsoUIObj.supplierImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCSupplierCommittedDate);
    _subsoUIObj.actualImpVSCRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCActualReceiptDate);
    _subsoUIObj.remarkImpVSCRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.importedVSCActualReceiptToken.addNotes);
    _subsoUIObj.plannedGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayPlannedReceiptDate);
    _subsoUIObj.requestedGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayRequestedReceiptDate);
    _subsoUIObj.supplierGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelaySupplierCommittedDate);
    _subsoUIObj.actualGERelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayActualReceiptDate);
    _subsoUIObj.remarkGERelayRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.geRelayActualReceiptToken.addNotes);
    _subsoUIObj.plannedCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTPlannedReceiptDate);
    _subsoUIObj.requestedCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTRequestedReceiptDate);
    _subsoUIObj.supplierCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTSupplierCommittedDate);
    _subsoUIObj.actualCTPTRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTActualReceiptDate);
    _subsoUIObj.remarkCTPTRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.ctPTActualReceiptToken.addNotes);
    _subsoUIObj.plannedRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayPlannedReceiptDate);
    _subsoUIObj.requestedRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayRequestedReceiptDate);
    _subsoUIObj.supplierRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relaySupplierCommittedDate);
    _subsoUIObj.actualRelayRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayActualReceiptDate);
    _subsoUIObj.remarkRelayRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.relayActualReceiptToken.addNotes);
    _subsoUIObj.plannedBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerPlannedReceiptDate);
    _subsoUIObj.requestedBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerRequestedReceiptDate);
    _subsoUIObj.supplierBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerSupplierCommittedDate);
    _subsoUIObj.actualBreakerRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerActualReceiptDate);
    _subsoUIObj.remarkBreakerRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.breakerActualReceiptToken.addNotes);
    _subsoUIObj.plannedJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperPlannedReceiptDate);
    _subsoUIObj.requestedJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperRequestedReceiptDate);
    _subsoUIObj.supplierJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperSupplierCommittedDate);
    _subsoUIObj.actualJumperRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperActualReceiptDate);
    _subsoUIObj.remarkJumperRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.jumperActualReceiptToken.addNotes);
    _subsoUIObj.plannedMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxPlannedReceiptDate);
    _subsoUIObj.requestedMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxRequestedReceiptDate);
    _subsoUIObj.supplierMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxSupplierCommittedDate);
    _subsoUIObj.actualMeterBoxRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxActualReceiptDate);
    _subsoUIObj.remarkMeterBoxRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.meteringBoxActualReceiptToken.addNotes);
    _subsoUIObj.plannedSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saPlannedReceiptDate);
    _subsoUIObj.requestedSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saRequestedReceiptDate);
    _subsoUIObj.supplierSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saSupplierCommittedDate);
    _subsoUIObj.actualSARcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.saActualReceiptDate);
    _subsoUIObj.remarkSARcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.saActualReceiptToken.addNotes);
    _subsoUIObj.plannedBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationPlannedReceiptDate);
    _subsoUIObj.requestedBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationRequestedReceiptDate);
    _subsoUIObj.supplierBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationSupplierCommittedDate);
    _subsoUIObj.actualBoughtoutFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationActualReceiptDate);
    _subsoUIObj.remarkBoughtoutFabricationRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.broughtoutFabricationActualReceiptToken.addNotes);

    _subsoUIObj.plannedInHouseFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationPlannedReceiptDate);
    _subsoUIObj.requestedInHouseFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationRequestedReceiptDate);
    _subsoUIObj.supplierInHouseFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationSupplierCommittedDate);
    _subsoUIObj.actualInHouseFabricationRcptDate = this.dtFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationActualReceiptDate);
    _subsoUIObj.remarkInHouseFabricationRcptDate = this.strFrmt(_subsoUIObj.sso.purchaseMatReceipt.inHouseFabricationActualReceiptToken.addNotes);

    _subsoUIObj.plannedMatIssuetoLineDate = this.dtFrmt(_subsoUIObj.sso.storeIP.materialIssueToLinePlannedDate);
    _subsoUIObj.requestedMatIssuetoLineDate = this.dtFrmt(_subsoUIObj.sso.storeIP.materialIssueToLineRequestLineLodingDate);
    _subsoUIObj.actualMatIssuetoLineDate = this.dtFrmt(_subsoUIObj.sso.storeIP.materialIssueToLineActualDate);
    _subsoUIObj.remarkMatIssuetoLineDate = this.strFrmt(_subsoUIObj.sso.storeIP.materialIssueToLineActualToken.addNotes);
    _subsoUIObj.plannedLooseMatIssueDate = this.dtFrmt(_subsoUIObj.sso.storeIP.looseMaterialIssueToDispatchPlannedDate);
    _subsoUIObj.looseMaterialIssueToDispatchRequestDate= this.dtFrmt(_subsoUIObj.sso.storeIP.looseMaterialIssueToDispatchRequestDate);
    _subsoUIObj.actualLooseMatIssueDate = this.dtFrmt(_subsoUIObj.sso.storeIP.looseMaterialIssueToDispatchActualDate);
    _subsoUIObj.remarkLooseMatIssueDate = this.strFrmt(_subsoUIObj.sso.storeIP.looseMaterialIssueToDispatchActualToken.addNotes);
    _subsoUIObj.plannedMechStickerDate = this.dtFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerPlannedDate);
    _subsoUIObj.requestedMechStickerDate = this.dtFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerRequestedDate);
    _subsoUIObj.actualMechStickerDate = this.dtFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerActualDate);
    _subsoUIObj.remarkMechStickerDate = this.strFrmt(_subsoUIObj.sso.productionIP.mechanicalStickerActualToken.addNotes);
    _subsoUIObj.plannedMechElecTestDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingPlannedDate);
    _subsoUIObj.requestedMechElecTestDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingRequestedDate);
    _subsoUIObj.actualMechElecTestDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingActualDate);
    _subsoUIObj.remarkMechElecTestDate = this.strFrmt(_subsoUIObj.sso.qualityIP.mechanicalElectricalTestingActualToken.addNotes);
    _subsoUIObj.plannedFATDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.fatPlannedDate);
    _subsoUIObj.requestedFATDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.fatRequestedDate);
    _subsoUIObj.actualFATDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.fatActualDate);
    _subsoUIObj.remarkFATDate = this.strFrmt(_subsoUIObj.sso.qualityIP.fatActualToken.addNotes);
    _subsoUIObj.plannedGreenStickerDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.greenStickerPlannedDate);
    _subsoUIObj.requestedGreenStickerDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.greenStickerRequestedDate);
    _subsoUIObj.actualGreenStickerDate = this.dtFrmt(_subsoUIObj.sso.qualityIP.greenStickerActualDate);
    _subsoUIObj.remarkGreenStickerDate = this.strFrmt(_subsoUIObj.sso.qualityIP.greenStickerActualToken.addNotes);
    _subsoUIObj.plannedDispatchDate = this.dtFrmt(_subsoUIObj.sso.logisticIP.dispatchFromPlantPlannedDate);
    _subsoUIObj.requestedDispatchDate = this.dtFrmt(_subsoUIObj.sso.logisticIP.dispatchFromPlantRequestDate);


    var _pDeliveries = this.getPartialDispatches(_subsoUIObj.sso);
    _subsoUIObj.actualDispatchDate = _pDeliveries.dispatchDate;
    _subsoUIObj.remarkDispatchDate = _pDeliveries.notes;
    _subsoUIObj.partialDispatchQty = _pDeliveries.dispatchQty;

    _subsoUIObj.actualEarthlingTruckDispatchDate = this.dtFrmt(_subsoUIObj.sso.logisticIP.earthlingTruckActualDispatchDate);
    _subsoUIObj.actualSparesDispatchDate = this.dtFrmt(_subsoUIObj.sso.logisticIP.sparesActualDispatchDate);


    this.headRows.forEach((_headCellDef:TblHeadCellDef) => {
      _subsoUIObj.cellRowSpan[_headCellDef.cellIndex] = this.getCellRowSpan(_subsoUIObj,_headCellDef.cellIndex);
    })
    //_subsoUIObj.cellRowSpan

  }
  getPartialDispatches(sso: SubSalesOrder): any {
    var retVal: any = { "dispatchQty": "", "dispatchDate": "", "notes": "" };

    sso.logisticIP.partialDeliveries.forEach((_pDelivery: PartialDelivery) => {
      var _divider = '\n';
      retVal.dispatchQty += (retVal.dispatchQty != '' ? _divider : '') + this.convNumToStr(_pDelivery.partialDispatchQty);
      retVal.dispatchDate += (retVal.dispatchDate != '' ? _divider : '') + this.dtFrmt(_pDelivery.dispatchFromPlantActualToken.actualDate);
      retVal.notes += (retVal.notes != '' ? _divider : '') + this.strFrmt(_pDelivery.dispatchFromPlantActualToken.addNotes);
    });
    return retVal;
  }
  getEquipType(_equip: Equipment, brk: BreakerPS): any {
    var retVal: any = { "equipType": "", "breakerType": "", "qtyOfPanel": "", "contractualvalue": "", "VSCQuantity ": "", "qtyOfBreaker": "", "breakerPS": "", "importedSwitch": "" };

    retVal.equipType = this._dataService.getEquipmentTypeName(_equip.equipmentType);
    retVal.breakerType = this._dataService.getBreakerTypeName(_equip.breakerType);
    retVal.qtyOfPanel = this.frmtNumStr(_equip.panelQuantity);
    retVal.contractualvalue = this.frmtNumStr(_equip.contractualValue);
    retVal.VSCQuantity = this.frmtNumStr(_equip.vscQuantity);
    retVal.totalqtyOfBreaker =  _equip.totalBreakerQuantity
    // if(brk){
      retVal.breakerPS = this.strFrmt(brk.breakerPs);
      retVal.qtyOfBreaker = brk.breakerQuantity;
   // }
    retVal.importedSwitch = this._dataService.getApplicabilityOptionName(_equip.earthSwithApplicability);


    return retVal;
  }
  strFrmt(_str: string) {
    if (_str) return _str;
    return '';
  }
  frmtNumStr(_numstr: string) {
    if (_numstr) return _numstr;
    return '';
  }
  convNumToStr(_num: number) {
    if (_num) return _num + '';
    return '';
  }
  dtFrmt(_dt: Date): string {
    return GenService.getDateFormatStr(_dt, 'd-mmm-YY')
  }
  monthFrmt(_dt: Date): string {
    return GenService.getDateFormatStr(_dt, 'mmm-YY')
  }

  getCellRowSpan(_ssoEquipUIObj: UiTblSubSOBrkPSLevel, _columnIndex: number) {

    switch (_columnIndex) {
      //Sale Order level items here
      case 0: case 1: case 2: case 3: case 15: case 21: case 22: case 26: case 28: case 29: case 29: case 30:
      case 31: case 32: case 33: case 34: case 35: case 36: case 37: case 38: case 39: case 40: case 43: case 44:
      case 45: case 47: case 49: case 51: case 52: case 53: case 54: case 55: case 56: case 57: case 58: case 59:
      case 60: case 61: case 62: case 63: case 64: case 65: case 66: case 67: case 68: case 69: case 70: case 71:
      case 72: case 73: case 74: case 75: case 76: case 77: 

        // case 24: case 25: case 26:  case 27:
        // case 28: case 29: case 30: case 31: case 32: case 33:  case 34: case 35: case 36: case 37: case 38:
        // case 41: case 42: case 43: case 45: case 47: case 49:  case 50:  case 51: case 52: case 53: case 54:
        // case 55: case 56: case 57: case 58: case 59: case 60: case 61: case 62: case 63: case 64:
        // case 65: case 66: case 67: case 68: case 69: case 70: case 71: case 72: case 73: case 74: case 75:


        if (_ssoEquipUIObj.isFirstRowInSO)
          return _ssoEquipUIObj.totalBreakerPsCountForSo;
        else
          return 0;

        break;

      //Sub Order Level Items here
      case 4: case 5: case 6: case 7: case 15: case 16: case 17: case 18: case 19: case 20: case 22: case 23: case 24: 
      case 25:case 27: case 39: case 40: case 41: case 42: case 43: case 44: case 46: case 47: case 50: case 48: 
      case 75: case 76: case 77: case 78: case 79: case 80: case 81: case 82: case 83: case 84: case 85: case 86: 
      case 87: case 88: case 89: case 90: case 91: case 92: case 95: case 96: case 97: case 98: case 99: case 93: case 94:
      case 100: case 101: case 102: case 103: case 104: case 105: case 106: case 107: case 108: case 109: case 110:
      case 111: case 112: case 113: case 114: case 115: case 116: case 117: case 118: case 119: case 120: case 121:
      case 122: case 123: case 124: case 125: case 126: case 127: case 128: case 129: case 130: case 131: case 132:
      case 133: case 134: case 135: case 136: case 137: case 138: case 139: case 140: case 141: case 142: case 143: 
      case 144: case 145: case 146: case 147: case 148: case 149: case 150: case 151: case 152: case 153: case 154: 
      case 155: case 156: case 157: case 158: case 159: case 160: case 161: case 162: case 163: case 164: case 165: 
      case 166: case 167: case 168: case 169: case 170: case 171: case 172: case 173: case 174: case 175: case 176: 
      case 177: case 178: case 179: case 180: case 181: case 182: case 183: case 184: case 185: case 186: case 187: 
      case 188: case 189: case 190: case 191: case 192: case 193: case 194: case 195: case 196: case 197: case 198: 
      case 199: case 200: case 201: case 202: case 203: case 204: case 205: case 206: case 207: case 208: case 209: 
      case 210: case 211: case 212: case 213: case 214: case 215: case 216: case 217: case 218: case 219: case 220: 
      case 221: case 222: case 223: case 224: case 225: case 226: case 227: case 228: case 229: case 230: case 231: 
      case 232: case 233: case 234: case 235: case 236: case 237: case 238: case 239: case 240: case 241: case 242: 
      case 243: case 244: case 245: case 246: case 247: case 248: case 249: case 250: case 251: case 252: case 253: 
      case 254: case 255: case 256: case 257: case 258: case 259: case 260: case 245: case 246: case 247: case 262:
      case 263:
    

        if (_ssoEquipUIObj.isFirstRowInSubOrder) {

          return _ssoEquipUIObj.totalBreakerPsCountForSubSo;
        }
        else
          return 0;

        break;

      case 8: case 9: case 10: case 11: case 12:

        if (_ssoEquipUIObj.isFirstRowInEquipment) {

          return _ssoEquipUIObj.totalBreakerPsCountForEquip;
        }
        else
          return 0;

    }


    return 1;
  }

  getCellValue(_ssoUIObj: UiTblSubSOBrkPSLevel, _paramNumber: number): string {
    //console.log("_ssoUIObj::",_ssoUIObj);
    //console.log("_paramNumber::",_paramNumber);
    switch (_paramNumber) {
      case 0: // Plant Name
        return _ssoUIObj.plantName;
      case 1: // Customer Name
        return _ssoUIObj.customerName;
      case 2:// Project name
        return _ssoUIObj.projectName;
      case 3: //OrderType
        return _ssoUIObj.ordertypeName;
      case 4:// Sales Order No
        return _ssoUIObj.salesOrderNo;
      case 5: //Sub Sales Order No
        return _ssoUIObj.salesOrderNoNew;
      case 6: //New Sale Order No
        return _ssoUIObj.subSalesOrderNo;
      case 7: //Board Name
        return _ssoUIObj.boardname;
      case 8://planned manf month
        return _ssoUIObj.plannedManfMonth;
      case 9: //Invoicing Month
        return _ssoUIObj.invoicingmonth;
      case 10://Planned revenue Month
        return _ssoUIObj.plannedRevenueMonth;
      case 11://variant of product
        return _ssoUIObj.variantOfProduct;
      case 12://type of equipment
      // console.log("type equip", _ssoUIObj.typeOfEquipment)
        return _ssoUIObj.typeOfEquipment;
      case 13://type of breaker
        return _ssoUIObj.typeOfBreaker;
      case 14://qty of panel
        return _ssoUIObj.qtyOfPanel;
      case 15://qty of breaker
        return _ssoUIObj.qtyOfVSC;
      case 16://qty of vsc
        return _ssoUIObj.totalqtyOfBreaker;
      case 17://Customer PO value
        return _ssoUIObj.breakerPS;
      case 18:
        // console.log(_ssoUIObj.qtyOfBreaker )
        return _ssoUIObj.qtyOfBreaker ///////////////////////////////////change this quantity breaker
      case 19:
      return _ssoUIObj.customerPoValue
      
      case 20://contractual value
        return _ssoUIObj.contractualValue;
      case 21://manf strategy
        return _ssoUIObj.manfStrategy;
      case 22://planned line loading date
        return _ssoUIObj.plndLineLoadingDate;
      case 23://requested line loading date
        return _ssoUIObj.reqLineLoadingDate;
      case 24://actual line loading date
        return _ssoUIObj.actLineLoadingDate;
      case 25://marketing engineer
        return _ssoUIObj.marketingEngineer;
      case 26://project manager
        return _ssoUIObj.projectManager;
      case 27://project engineer
        return _ssoUIObj.projectEngineer;
      case 28://Electrical D engineer
        return _ssoUIObj.elecDesignEngineer;
      case 29://Mechnical D engineer
        return _ssoUIObj.mechDesignEngineer;
      case 30:// return sales channel name
        return _ssoUIObj.salesChannelName;
      case 31://region name
        return _ssoUIObj.regionName;
      case 32://purchase order date
        return _ssoUIObj.poDate;
      case 33://clear po recpt date
        return _ssoUIObj.clearPODate;
      case 34://consultane name
        return _ssoUIObj.consultantName;
      case 35://warranty months
        return _ssoUIObj.warrantyMonths;
      case 36://special point
        return _ssoUIObj.specialPoint;
      // case 35: //OrderType
      //   return _ssoUIObj.ordertypeName;
      case 37://contractual delivery firm
        return _ssoUIObj.contractDeliveryFirm;
      case 38://contrautial delivery in weeks
        return _ssoUIObj.contractDeliveryWeeks;
      case 39://contractual delivery date
        return _ssoUIObj.contractDeliveryDate;
      case 40://ld applicability
        return _ssoUIObj.ldApplicability;
      case 41://ld %
        return _ssoUIObj.ldPercentage;
      case 42://ld cap
        return _ssoUIObj.ldCap;
      case 43://delivery term
        return _ssoUIObj.deliveryTerm;
      case 44://place of delivery
        return _ssoUIObj.placeOfDelivery;
      case 45://no of days to reach
        return _ssoUIObj.daysgoodsReach 
      case 46://delviry from abb
        return _ssoUIObj.deliveryFromAbb;
      case 47://payment term
        return _ssoUIObj.paymentTerm;
      case 48://payment days
        return _ssoUIObj.paymentDays;
      case 49://FCM Mat cost
        return _ssoUIObj.FCMMatCost;
      case 50://JSR Mat cost
        return _ssoUIObj.JSRMatCost;
      case 51://FCM GM
        return _ssoUIObj.FCMGM;
      case 52://JSR GM
        return _ssoUIObj.JSRGM;
      case 53://FCM NM
        return _ssoUIObj.FCMNM;
      case 54://JSR NM
        return _ssoUIObj.JSRNM;
      case 55://Adv pmt Condition
        return _ssoUIObj.AdvPmtCondition;
      case 56://Adv Payment
        return _ssoUIObj.AdvPmt;
      case 57://Adv Payment Milestone
        return _ssoUIObj.AdvPmtMilestone;
      case 58://PBG Pay Condiiton
        return _ssoUIObj.PBGPayCondition;
      case 59://CPBG Pay Condiiton
        return _ssoUIObj.CPBGPayCondition;
      case 60://SO Creation Planned
        return _ssoUIObj.SOCreationPlanned;
      case 61://SO Creation Actual
        return _ssoUIObj.SOCreationActual;
      case 62://SO Creation Actual remarks
        return _ssoUIObj.SOCreationRemarks;
      case 63://SO Release Planned
        return _ssoUIObj.SOReleasePlanned;
      case 64://SO Release Actual
        return _ssoUIObj.SOReleaseActual;
      case 65://SO Release remarks
        return _ssoUIObj.SOReleaseRemarks;
      case 66://SO Release Planned
        return _ssoUIObj.OrderHandOverPlanned;
      case 67://SO Release Actual
        return _ssoUIObj.OrderHandOverActual;
      case 68://SO Release remarks
        return _ssoUIObj.OrderHandOverRemarks;
      case 69://abg acg submission details
        return _ssoUIObj.ABGACGSubmissionDetails;
      case 70://abg/acg planned submission date
        return _ssoUIObj.ABGACGSubmissionPlannedDate
      case 71://abg/acg submission date
        return _ssoUIObj.ABGACGActSubmissDate;
      case 72://abg/acg planned colleciton date
        return _ssoUIObj.abgOrAcgPlndCollDate;
      case 73://abg/acg colleciton date
        return _ssoUIObj.ABGACGActCollectDate;
      case 74://PBG submission details
        return _ssoUIObj.PBGSubmissionDetails;
      case 75://pbg planned submission date
        return _ssoUIObj.pbgPlndSubDate
      case 76:
        return _ssoUIObj.pbgReqSubDate
      case 77:
        return _ssoUIObj.PBGActSubmissDate;
      case 78:
        return _ssoUIObj.PBGActCollectDate;
      case 79:
        return _ssoUIObj.CPBGSubmissionDetails;
      case 80:
        return _ssoUIObj.CPBGActSubmissDate;
      case 81:
        return _ssoUIObj.CPBGActCollectDate;
      // case 78: //Board Name
      //   return _ssoUIObj.boardname;
      case 82:
        return _ssoUIObj.complexityOfJobs;
      // case 82:
      //   return _ssoUIObj.noOfFeedertypes;
      case 83:
        return _ssoUIObj.plannedSLDSubmissDate;
      case 84:
        return _ssoUIObj.initialSLDSubmissActualDate;
      case 85:
        return _ssoUIObj.remarkSLDApprovalDate
      case 86:
        return _ssoUIObj.plannedGAFDrawSubmissDate;
      case 87:
        return _ssoUIObj.actualGAFDrawSubmissDate
      case 88:
        return _ssoUIObj.remarkForGAFSubmissActualDate;
      case 89:
        return _ssoUIObj.plannedSchBOMSubmissDate;
      case 90:
        return _ssoUIObj.actualSchBOMSubmisDate
      case 91:
        return _ssoUIObj.remarkSchBOMSubmissDate
      case 92:
        return _ssoUIObj.plannedBusBarSizingCalcSubmissDate
      case 93:
        return _ssoUIObj.actualBusBarSizingCalcSubmissDate
      case 94:
        return _ssoUIObj.remarkBusBarSizingCalcSubmissDate
      case 95:
        return _ssoUIObj.finalDrawingSubmissDate;
      case 96:
        return _ssoUIObj.insulationLevelKV;
      // case 95:
      // return _ssoUIObj.breakerPS;
      case 97:
        return _ssoUIObj.importedEarthingSwitchApplicability;
      case 98:
        return _ssoUIObj.kioskApplic;
      case 99:
        return _ssoUIObj.tempRiseTestApplic;
      case 100:
        return _ssoUIObj.impBrkApplic;
      case 101:
        return _ssoUIObj.impVSCApplic;
      case 102:
        return _ssoUIObj.spareApplic;
      case 103:
        return _ssoUIObj.etApplic;
      case 104:
        return _ssoUIObj.geRelayApplic;
      case 105:
        return _ssoUIObj.busbarMaterial;
      case 106:
        return _ssoUIObj.busbarSleeve;
      case 107:
        return _ssoUIObj.cmntOnActualSubmissDate;
      case 108:
        return _ssoUIObj.cmntOnActualComplainceDate;
      case 108:
        return _ssoUIObj.plannedDrawingAprvlDate;
      case 110:
        return _ssoUIObj.actualDrawingAprvlDate;
      case 111:
        return _ssoUIObj.remarkDrawingAprvlDate;
      case 112:
        return _ssoUIObj.plannedCTFinalEnggToPMDate
      case 113:
        return _ssoUIObj.actualCtFinalEnggToPMDate;
      case 114:
        return _ssoUIObj.remarkCtFinalEnggToPMDate;
      case 115:
        return _ssoUIObj.plannedSpecialPriceGvnbyENGGtoPM;
      case 116:
        return _ssoUIObj.actualSpecialPriceGvnbyENGGtoPM;
      case 117:
        return _ssoUIObj.remarkSpecialPriceGvnbyENGGtoPM;
      case 118:
        return _ssoUIObj.plannedCTFinalPMtoSCMDate;
      case 119:
        return _ssoUIObj.actualCTFinalPMtoSCMDate;
      case 120:
        return _ssoUIObj.remarkCTFinalPMtoSCMDate;
      case 121:
        return _ssoUIObj.plannedSpecialMatPricePmtoSCm;
      case 122:
        return _ssoUIObj.actualSpecialMatPricePmtoSCm;
      case 123:
        return _ssoUIObj.remarkSpecialMatPricePmtoSCm;
      case 124:
        return _ssoUIObj.plannedCTFinalfromSCMDate;
      case 125:
        return _ssoUIObj.actualCTFinalfromSCMDate;
      case 126:
        return _ssoUIObj.remarkCTFinalfromSCMDate;
      case 127:
        return _ssoUIObj.plannedSpecialMatPricefromSCMDate;
      case 128:
        return _ssoUIObj.actualSpecialMatPricefromSCMDate;
      case 129:
        return _ssoUIObj.remarkSpecialMatPricefromSCMDate;


      case 130:
        return _ssoUIObj.plannedPackingDispatchClrDate;
      case 131:
        return _ssoUIObj.requestedPackingDispatchClrDate;
      case 132:
        return _ssoUIObj.actualPackingDispatchClrDate;
      case 133:
        return _ssoUIObj.remarkPackingDispatchClrDate;
      case 134:
        return _ssoUIObj.plannedSLDApprovalDate
      case 135:
        return _ssoUIObj.actualSLDApprovalDate
      case 136:
        return _ssoUIObj.remarkSLDApprovalDate
      case 137:
        return _ssoUIObj.plannedC40Date;
      case 138:
        return _ssoUIObj.actualC40Date;
      case 139:
        return _ssoUIObj.remarkC40Date;
      case 140:
        return _ssoUIObj.plannedC50Date;
      case 141:
        return _ssoUIObj.actualC50Date;
      case 142:
        return _ssoUIObj.remarkC50Date;
      case 143:
        return _ssoUIObj.plannedC60Date;
      case 144:
        return _ssoUIObj.actualC60Date;
      case 145:
        return _ssoUIObj.remarkC60Date;
      case 146://plannedLongLeadDate
        return _ssoUIObj.plannedLongLeadDate;
      case 147:
        return _ssoUIObj.actualLongLeadDate;
      case 148:
        return _ssoUIObj.remarkLongLeadDate;


      case 149://plannedImpBrkrPORlsDate
        return _ssoUIObj.plannedImpBrkrPORlsDate;
      case 150:
        return _ssoUIObj.actualImpBrkrPORlsDate;
      case 151:
        return _ssoUIObj.remarkImpBrkrPORlsDate;
      case 152://plannedImpVscPORlsDate
        return _ssoUIObj.plannedImpVscPORlsDate;
      case 153:
        return _ssoUIObj.actualImpVscPORlsDate;
      case 154:
        return _ssoUIObj.remarkImpVscPORlsDate;
      case 155://plannedGERelayPORlsDate
        return _ssoUIObj.plannedGERelayPORlsDate;
      case 156:
        return _ssoUIObj.actualGERelayPORlsDate;
      case 157:
        return _ssoUIObj.remarkGERelayPORlsDate;
      case 158://plannedCTPTPORlsDate
        return _ssoUIObj.plannedCTPTPORlsDate;
      case 159:
        return _ssoUIObj.actualCTPTPORlsDate;

      case 160:
        return _ssoUIObj.remarkCTPTPORlsDate;
      case 161://plannedRelayPORlsDate
        return _ssoUIObj.plannedRelayPORlsDate;
      case 162:
        return _ssoUIObj.actualRelayPORlsDate;
      case 163:
        return _ssoUIObj.remarkRelayPORlsDate;
      case 164://plannedBreakerPORlsDate
        return _ssoUIObj.plannedBreakerPORlsDate;
      case 165:
        return _ssoUIObj.actualBreakerPORlsDate;
      case 166:
        return _ssoUIObj.remarkBreakerPORlsDate;
      case 167://plannedSAPORlsDate
        return _ssoUIObj.plannedSAPORlsDate;
      case 168:
        return _ssoUIObj.actualSAPORlsDate;
      case 169:
        return _ssoUIObj.remarkSAPORlsDate;
      case 170://plannedMeteringBoxPORlsDate
        return _ssoUIObj.plannedMeteringBoxPORlsDate;
      case 171:
        return _ssoUIObj.actualMeteringBoxPORlsDate;

      case 172:
        return _ssoUIObj.remarkMeteringBoxPORlsDate;
      case 173://plannedPickListtoStoresDate
        return _ssoUIObj.plannedPickListtoStoresDate;
      case 174:
        return _ssoUIObj.requestedPickListtoStoresDate;
      case 175:
        return _ssoUIObj.actualPickListtoStoresDate;
      case 176:
        return _ssoUIObj.remarkPickListtoStoresDate;
      case 177://plannedImpBrkrRcptDate
        return _ssoUIObj.plannedImpBrkrRcptDate;
      case 178:
        return _ssoUIObj.requestedImpBrkrRcptDate;
      case 179:
        return _ssoUIObj.supplierImpBrkrRcptDate;
      case 180:
        return _ssoUIObj.actualImpBrkrRcptDate;
      case 181:
        return _ssoUIObj.remarkImpBrkrRcptDate;
      case 182://plannedImpBrkrRcptDate
        return _ssoUIObj.plannedImpVSCRcptDate;
      case 183:
        return _ssoUIObj.requestedImpVSCRcptDate;
      case 184:
        return _ssoUIObj.supplierImpVSCRcptDate;
      case 185:
        return _ssoUIObj.actualImpVSCRcptDate;
      case 186:
        return _ssoUIObj.remarkImpVSCRcptDate;
      case 187://plannedGERelayRcptDate
        return _ssoUIObj.plannedGERelayRcptDate;
      case 188:
        return _ssoUIObj.requestedGERelayRcptDate;
      case 189:
        return _ssoUIObj.supplierGERelayRcptDate;
      case 190:
        return _ssoUIObj.actualGERelayRcptDate;
      case 191:
        return _ssoUIObj.remarkGERelayRcptDate;
      case 192://plannedCTPTRcptDate
        return _ssoUIObj.plannedCTPTRcptDate;
      case 193:
        return _ssoUIObj.requestedCTPTRcptDate;
      case 194:
        return _ssoUIObj.supplierCTPTRcptDate;
      case 195:
        return _ssoUIObj.actualCTPTRcptDate;
      case 196:
        return _ssoUIObj.remarkCTPTRcptDate;
      case 197://plannedRelayRcptDate
        return _ssoUIObj.plannedRelayRcptDate;
      case 198:
        return _ssoUIObj.requestedRelayRcptDate;
      case 199:
        return _ssoUIObj.supplierRelayRcptDate;
      case 200:
        return _ssoUIObj.actualRelayRcptDate;
      case 201:
        return _ssoUIObj.remarkRelayRcptDate;
      case 202://plannedBreakerRcptDate
        return _ssoUIObj.plannedBreakerRcptDate;
      case 203:
        return _ssoUIObj.requestedBreakerRcptDate;
      case 204:
        return _ssoUIObj.supplierBreakerRcptDate;
      case 205:
        return _ssoUIObj.actualBreakerRcptDate;
      case 206:
        return _ssoUIObj.remarkBreakerRcptDate;
      case 207://plannedJumperRcptDate
        return _ssoUIObj.plannedJumperRcptDate;
      case 208:
        return _ssoUIObj.requestedJumperRcptDate;
      case 209:
        return _ssoUIObj.supplierJumperRcptDate;
      case 210:
        return _ssoUIObj.actualJumperRcptDate;
      case 211:
        return _ssoUIObj.remarkJumperRcptDate;

      case 212://plannedMeterBoxRcptDate
        return _ssoUIObj.plannedMeterBoxRcptDate;
      case 213:
        return _ssoUIObj.requestedMeterBoxRcptDate;
      case 214:
        return _ssoUIObj.supplierMeterBoxRcptDate;
      case 215:
        return _ssoUIObj.actualMeterBoxRcptDate;
      case 216:
        return _ssoUIObj.remarkMeterBoxRcptDate;
      case 217://plannedSARcptDate
        return _ssoUIObj.plannedSARcptDate;
      case 218:
        return _ssoUIObj.requestedSARcptDate;
      case 219:
        return _ssoUIObj.supplierSARcptDate;
      case 220:
        return _ssoUIObj.actualSARcptDate;
      case 221:
        return _ssoUIObj.remarkSARcptDate;
      case 222://plannedBoughtoutFabricationRcptDate
        return _ssoUIObj.plannedBoughtoutFabricationRcptDate;
      case 223:
        return _ssoUIObj.requestedBoughtoutFabricationRcptDate;
      case 224:
        return _ssoUIObj.supplierBoughtoutFabricationRcptDate;
      case 225:
        return _ssoUIObj.actualBoughtoutFabricationRcptDate;
      case 226:
        return _ssoUIObj.remarkBoughtoutFabricationRcptDate;
      case 227://plannedInHouseFabricationRcptDate
        return _ssoUIObj.plannedInHouseFabricationRcptDate;
      case 228:
        return _ssoUIObj.requestedInHouseFabricationRcptDate;
      case 229:
        return _ssoUIObj.supplierInHouseFabricationRcptDate;
      case 230:
        return _ssoUIObj.actualInHouseFabricationRcptDate;
      case 231:
        return _ssoUIObj.remarkInHouseFabricationRcptDate;



      case 232://plannedMatIssuetoLineDate
        return _ssoUIObj.plannedMatIssuetoLineDate;
      case 233:
        return _ssoUIObj.requestedMatIssuetoLineDate;
      case 234:
        return _ssoUIObj.actualMatIssuetoLineDate;
      case 235:
        return _ssoUIObj.remarkMatIssuetoLineDate;
      case 236://plannedLooseMatIssueDate
        return _ssoUIObj.plannedLooseMatIssueDate;
      case 237:
        return _ssoUIObj.looseMaterialIssueToDispatchRequestDate
      case 238:
        return _ssoUIObj.actualLooseMatIssueDate;
      case 239:
        return _ssoUIObj.remarkLooseMatIssueDate;
      case 240://plannedMechStickerDate
        return _ssoUIObj.plannedMechStickerDate;
      case 241:
        return _ssoUIObj.requestedMechStickerDate;
      case 242:
        return _ssoUIObj.actualMechStickerDate;
      case 243:
        return _ssoUIObj.remarkMechStickerDate;
      case 244://plannedMechElecTestDate
        return _ssoUIObj.plannedMechElecTestDate;
      case 245:
        return _ssoUIObj.requestedMechElecTestDate;
      case 246:
        return _ssoUIObj.actualMechElecTestDate;
      case 247:
        return _ssoUIObj.remarkMechElecTestDate;
      case 248://plannedFATDate
        return _ssoUIObj.plannedFATDate;
      case 249:
        return _ssoUIObj.requestedFATDate;
      case 250:
        return _ssoUIObj.actualFATDate;
      case 251:
        return _ssoUIObj.remarkFATDate;
      case 252://plannedGreenStickerDate
        return _ssoUIObj.plannedGreenStickerDate;
      case 253:
        return _ssoUIObj.requestedGreenStickerDate;
      case 254:
        return _ssoUIObj.actualGreenStickerDate;
      case 255:
        return _ssoUIObj.remarkGreenStickerDate
      case 256://plannedDispatchDate
        return _ssoUIObj.plannedDispatchDate;
      case 257://requestedDispatchDate
        return _ssoUIObj.requestedDispatchDate;
      case 258:
        return _ssoUIObj.actualDispatchDate;
      case 259:
        return _ssoUIObj.remarkDispatchDate;
      case 260:
        return _ssoUIObj.partialDispatchQty;
      case 261:
        return _ssoUIObj.actualEarthlingTruckDispatchDate;
      case 262:        
        return _ssoUIObj.actualSparesDispatchDate;      
      case 263: //ROTD Date        
        return _ssoUIObj.rotddate;
    }
    return '-';
  }
  reloadData(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.loadData();  
    }, 2);
  }
  getColumnName(_index: number): string {
    return GenService.getExcelColumnName(_index);
  }
  tableScrolledLeft: boolean = false;
  onScroll(_scrlEvnt: any) {
    if (_scrlEvnt && _scrlEvnt.srcElement) {
      let _scrollLeft: number = _scrlEvnt.srcElement.scrollLeft;
      let _newSetting = (_scrollLeft > 150) ? true : false;
      if(this.tableScrolledLeft != _newSetting){
        this.tableScrolledLeft = _newSetting
      }
    }
  }
  downloadExcel() {
    this._dataService.downloadFile('mast');
  }
  downloadExcelmark() {
    this._dataService.downloadFile('mrktg');
  }
  downloadExcelbrkrp() {
    this._dataService.downloadFile('brkrp');
  }
  downloadExceldspch() {
    this._dataService.downloadFile('dspch');
  }

  // _rowCounter:number = 0;
  // getRowHeader(_sno: number, _rowHeader: string) {
  //   if (this.tableScrolledLeft == true) {
  //     return _rowHeader;
  //   }
  //   if(_sno == 0) this._rowCounter = 0;
  //   return (++this._rowCounter) + '';
  // }

  getHeadCssClass(_group: UITblGroup): string {
    switch (_group) {
      case UITblGroup.Marketing:
        return 'head-mrkt';
      case UITblGroup.ProjManagement:
        return 'head-pm';
      case UITblGroup.SCM:
        return 'head-scm';
      case UITblGroup.Engineering:
        return 'head-engg';
      case UITblGroup.PurchasePO:
        return 'head-po';
      case UITblGroup.Planning:
        return 'head-plan';
      case UITblGroup.PurchaseMatReceipt:
        return 'head-matrcpt';
      case UITblGroup.Store:
        return 'head-store';
      case UITblGroup.Production:
        return 'head-prod';
      case UITblGroup.Quality:
        return 'head-qual';
      case UITblGroup.Logistics:
        return 'head-log';

    }

    return '';
  }

  filterRows(): void {
    let _filteredSSO: Array<UiTblSubSOBrkPSLevel> = this._filterPipe.transform(this._breakerPSUIObjList, this.search);

    // let _tmpRowSpanArr:any = {};

    // let _tmpSubSOIndex:number = 0;
    // _filteredSSO.forEach((_subSOBrkPS:UiTblSubSOBrkPSLevel) => {

    //   let _tmpHeadCellIndex:number  = 0;
    //   this.filteredHeadRows.forEach((headCell:TblHeadCellDef) => {
    //       if(_tmpRowSpanArr[_tmpSubSOIndex] == null){
    //         _tmpRowSpanArr[_tmpSubSOIndex] = {};
    //       }
    //       _tmpRowSpanArr[_tmpSubSOIndex][_tmpHeadCellIndex] = this.getCellRowSpan(_subSOBrkPS, _tmpHeadCellIndex);

    //       _tmpHeadCellIndex++;
    //   });

    //   _tmpSubSOIndex++;
    // });
    // this._rowSpanArr = _tmpRowSpanArr;
    this._filteredSubSoUIObjList = _filteredSSO;
    //console.log("this._filteredSubSoUIObjList::",this._filteredSubSoUIObjList)
    this.cd.markForCheck();
  }
  arrangeHeadColumns(): void {
    this.isLoading = true;
    // setTimeout(() => {
      let tmpHeadRows: Array<TblHeadCellDef> = [];
      this.headRows.forEach((_Obj: TblHeadCellDef) => {
        var isColumnReq: boolean = true;

        switch (_Obj.cellGroup) {
          case UITblGroup.Marketing:
            if (this.tblModStatus.showMarketing == false) isColumnReq = false;
            break;
          case UITblGroup.ProjManagement:
            if (this.tblModStatus.showPM == false) isColumnReq = false;
            break;
          case UITblGroup.SCM:
            if (this.tblModStatus.showSCM == false) isColumnReq = false;
            break;
          case UITblGroup.Engineering:
            if (this.tblModStatus.showEngg == false) isColumnReq = false;
            break;
          case UITblGroup.PurchasePO:
            if (this.tblModStatus.showPO == false) isColumnReq = false;
            break;
          case UITblGroup.Planning:
            if (this.tblModStatus.showPlanning == false) isColumnReq = false;
            break;
          case UITblGroup.PurchaseMatReceipt:
            if (this.tblModStatus.showMatReceipt == false) isColumnReq = false;
            break;
          case UITblGroup.Store:
            if (this.tblModStatus.showStore == false) isColumnReq = false;
            break;
          case UITblGroup.Production:
            if (this.tblModStatus.showProduction == false) isColumnReq = false;
            break;
          case UITblGroup.Quality:
            if (this.tblModStatus.showQuality == false) isColumnReq = false;
            break;
          case UITblGroup.Logistics:
            if (this.tblModStatus.showLogistics == false) isColumnReq = false;
            break;

        }

        if (isColumnReq == true) {
          tmpHeadRows.push(_Obj);
        }
      });

      this.filteredHeadRows = tmpHeadRows;
      this.isLoading = false;
      this.cd.markForCheck();
    // }, 2);
  }

  getFooterText(_columnIndex: number): string {
    let aggType: AggregateType = this.filteredHeadRows[_columnIndex].aggregateType
    let _sum: number = 0;
    if (this._filteredSubSoUIObjList && aggType != AggregateType.None) {
      switch (aggType) {
        case AggregateType.COUNT:
          return '';//this._filteredSubSoUIObjList.length + ' rows';
        case AggregateType.SUM:
          for (var i = 0; i < this._filteredSubSoUIObjList.length; i++) {
            let _tmpVal: number = parseFloat(this.getCellValue(this._filteredSubSoUIObjList[i], _columnIndex));
            if (configDefs.isNumEmty(_tmpVal) == false) {
              _sum += _tmpVal;
            }
          }
          return _sum.toFixed(2);
      }

    }
    return '';

  }

  getDownloadLink(_fObj: FileElement) {
    return '/downloadfile?actname=' + encodeURIComponent(_fObj.filename) + '&fref=' + _fObj.fileref;
  }

  public getSpecialPointFiles(subSOTbl: UiTblSubSOBrkPSLevel) {
    return subSOTbl.specialPointFiles;
  }

  screenToggle() {
    this.isFullScreenTbl = !this.isFullScreenTbl;
  }

  initTableHeaders(): Array<TblHeadCellDef> {
    let _tmpHeadRows: Array<TblHeadCellDef> = [];
    _tmpHeadRows.push(new TblHeadCellDef("Plant","",0,"auto",1,0));
    _tmpHeadRows.push(new TblHeadCellDef("Customer Name","",1,"auto",0,0));
    _tmpHeadRows.push(new TblHeadCellDef("Project Name","",2,"auto",0,0));
    _tmpHeadRows.push(new TblHeadCellDef("Order Type","",3,"auto",1,0));
    _tmpHeadRows.push(new TblHeadCellDef("Sale order number","",4,"auto",0,0));
    _tmpHeadRows.push(new TblHeadCellDef("New Sale order number","",5,"auto",0,0));
    _tmpHeadRows.push(new TblHeadCellDef("Sub Order Number","",6,"auto",0,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Board Name"," ",7,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned Manufacturing Month"," date-text",8,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Invoicing Month","date-text",9,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned Revenue Month"," date-text",10,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Variant of Product","",11,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Type of Equipment","wide-text",12,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Type of breaker","",13,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Quantity of panel","",14,"auto",2,1));
  //   _tmpHeadRows.push(new TblHeadCellDef("Quantity of VSC","",15,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Total Breaker Quantity","",16,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Breaker PS","wide-text",17,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Quantity of Breaker","",18,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Customer PO  value- MINR","",19,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Contractual Value (MINR)","",20,"auto",0,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Manufacturing strategy","",21,"auto",6,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned line loading date"," date-text",22,"auto",6,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Requested Line loading date"," date-text",23,"auto",6,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Line loading date - Actual"," date-text",24,"auto",9,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Marketing Engineer","wide-text",25,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Project Manager","wide-text",26,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Project Engineer","wide-text",27,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Electrical Design Engineer","wide-text",28,"auto",4,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Mechanical Design Engineer","wide-text",29,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Sale Channel","wide-text",30,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Cluster","",31,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Purchase order date"," date-text",32,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Clear PO receipt date- at ABB"," date-text",33,"auto",1,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Consultant Name","",34,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Warranty","",35,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Special point","wide-text",36,"auto",1,0));
  //  // _tmpHeadRows.push(new TblHeadCellDef("Order Type","",35,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Contractual Delivery Date Firm ","",37,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Contractual delivery date from drawing approval- In week","",38,"auto",1,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Contractual delivery date"," date-text",39,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("LD Applicability","",40,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("LD%","",41,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("LD CAP","",42,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Delivery Term","",43,"auto",1,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Place of Delivery","",44,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("No of days to reach the goods at site","",45,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Expected Ex-works delivery Planned date"," date-text",46,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Payment Term","",47,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Number of payment days","",48,"auto",1,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("FCM Mat cost","",49,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("JSR Mat cost","",50,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("FCM GM","",51,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("JSR GM","",52,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("FCM NM","",53,"auto",1,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("JSR NM","",54,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Adv Pmt Condition","",55,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Advance Payment","",56,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Adv Pmt Milestone","wide-text",57,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("PBG Payment condition","",58,"auto",1,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("CPBG Payment condition","",59,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SO creation date-planned"," date-text",60,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SO creation date- Actual"," date-text",61,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual SO Creation","wide-text",62,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SO released date- Planned"," date-text",63,"auto",1,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("SO released date- Actual"," date-text",64,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual SO Release","wide-text",65,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned Order Handing Over Date"," date-text",66,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Actual Order Handing Over Date"," date-text",67,"auto",1,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark for delay/ early Actual order handing over date","wide-text",68,"auto",1,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("ABG/ACG Submission Details","",69,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("ABG Planned submission date"," date-text",70,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("ABG/ACG actual submission date"," date-text",71,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("ABG Planned collection date"," date-text",72,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("ABG/ACG actual collection date"," date-text",73,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("PBG Submission Details"," date-text",74,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("PBG Planned submission date"," date-text",75,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("PBG requested sumission date"," date-text",76,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("PBG actual submission date"," date-text",77,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("PBG actual collection date"," date-text",78,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("CPBG Submission Details"," date-text",79,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CPBG actual submission date"," date-text",80,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CPBG actual collection date"," date-text",81,"auto",2,0));
  //       _tmpHeadRows.push(new TblHeadCellDef("Complexity of jobs","",82,"auto",2,0));
    
  //   //_tmpHeadRows.push(new TblHeadCellDef("Number of feeder types","",80,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned SLD submission date"," date-text",83,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Initial SLD submission date- Actual"," date-text",84,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark for delay/early initial actual SLD submission","wide-text",85,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned GA & Foundation drawing submission date"," date-text",86,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Initial GA & Foundation drawing submission date- Actual"," date-text",87,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark for delay/early initial actual GA & foundation  submission","wide-text",88,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned Schematic drawing & BOM submission date"," date-text",89,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Initail Schematic drawing & BOM submission date- Actual"," date-text",90,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark for delay/early initial actual schematic & BOM submission","wide-text",91,"auto",4,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned GTP, CT,PT, Busbar Sizing Calculation submission date"," date-text",92,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Initial GTP, CT,PT, Busbar Sizing Calculation submission date- Actual"," date-text",93,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark for delay/early initial actual CT,PT,busbar submission","wide-text",94,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Final drawing submission date-Actual"," date-text",95,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Insulation level- kV"," date-text",96,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported Earth Switch Applicability","",97,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("KIOSK Applicable","",98,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Temp. Rise Test Applicability","",99,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported  Breaker Applicability","",100,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported VSC Applicability","",101,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Spare Applicability","",102,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("ET Applicablity","",103,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Special relay applicability","",104,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Busbar Material","",105,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Busbar Sleeve","",106,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Comment received on submission -Actual  date"," date-text",107,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Compliance submission against comment- Actual date"," date-text",108,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned drawing approval date"," date-text",109,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Actual drawing approval date"," date-text",110,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early  Actual  drawing approval","wide-text",111,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("CT finalization Given By Engg to PM  Planned date"," date-text",112,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT finalization Given By Engg to PM  Actual date"," date-text",113,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early actual CT finalization given by Engg to PM","wide-text",114,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned Special  Price Material (if Applicable) Given by Engg to PM"," date-text",115,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Actual Special  Price Material (if Applicable) Given by Engg to PM"," date-text",116,"auto",4,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early actual CT finalization given by Engg to PM","wide-text",117,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT finalization Given By PM to SCM- Planned date"," date-text",118,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT finalization Given By PM to SCM- Actual date"," date-text",119,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early actual CT finalization given by PM to SCM","wide-text",120,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned Special  Price Material (if Applicable) Given by PM to SCM "," date-text",121,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Actual Special Material  Price (if Applicable) Given by PM to SCM "," date-text",122,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early actual Special Material Price given by PM to SCM","wide-text",123,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT finalization from SCM- Planned date"," date-text",124,"auto",3,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT finalization from SCM- Actual date"," date-text",125,"auto",3,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early actual CT finalization by SCM","wide-text",126,"auto",3,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Special  material Price Planned Date"," date-text",127,"auto",3,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Special  material Price Actual Date"," date-text",128,"auto",3,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early actual CT finalization by SCM","wide-text",129,"auto",3,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Packing/dispatch clearnce - Planned date"," date-text",130,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Packing/dispatch clearance- requested date"," date-text",131,"auto",2,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Packing/dispatch clearnce -Actual date"," date-text",132,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early packing/dispatch clearnce ","wide-text",133,"auto",2,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SLD & GA approval Planned date"," date-text",134,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SLD & GA approval Actual date"," date-text",135,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual SLD & GA approval ","wide-text",136,"auto",4,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned C40 Date "," date-text",137,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Actual C40 Date "," date-text",138,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual C40 date","wide-text",139,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned C50 Date "," date-text",140,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Actual  C50 Date "," date-text",141,"auto",4,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual C50 date","wide-text",142,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Planned C60 Date "," date-text",143,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Actual  C60 Date "," date-text",144,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual C60 date","wide-text",145,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Long lead release date- Planned"," date-text",146,"auto",4,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Long lead release date- Actual"," date-text",147,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for long lead released ","wide-text",148,"auto",4,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported breaker PO released date- Planned"," date-text",149,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported breaker PO released date- Actual"," date-text",150,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual imported PO released ","wide-text",151,"auto",5,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported  VSC PO released date- Planned"," date-text",152,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported  VSC PO released date- Actual"," date-text",153,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual VSC PO released ","wide-text",154,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Special relay PO released date- Planned"," date-text",155,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Special relay PO released date- Actual"," date-text",156,"auto",5,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Special relay PO released ","wide-text",157,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT / PT PO release Date - planned"," date-text",158,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT / PT PO release Date - Actual"," date-text",159,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual CT/PT PO released ","wide-text",160,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Relay PO Release Date- planned"," date-text",161,"auto",5,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Relay PO Release Date- Actual"," date-text",162,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Relay PO released ","wide-text",163,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Breaker PO release Date - Planned"," date-text",164,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Breaker PO release Date - Actual"," date-text",165,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Breaker PO released ","wide-text",166,"auto",5,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("SA PO released Planned date"," date-text",167,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SA PO release Date - Actual"," date-text",168,"auto",0,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual SA  PO released ","wide-text",169,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Metering Box PO released date- Planned"," date-text",170,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Metering Box PO released date- Actual"," date-text",171,"auto",5,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Metering box PO released ","wide-text",172,"auto",5,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Pick list issue to stores- Planned date"," date-text",173,"auto",6,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Pick list issue to stores- Requested date"," date-text",174,"auto",6,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Pick list issue to stores- Actual date"," date-text",175,"auto",6,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual pick list issue to stores","wide-text",176,"auto",6,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported breaker Planned receipt date"," date-text",177,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported breaker Requested receipt date"," date-text",178,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported breaker Supplier  committed date"," date-text",179,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported breaker Actual receipt date"," date-text",180,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual imported breaker","wide-text",181,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported  VSC Planned receipt date"," date-text",182,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported  VSC Requested receipt date"," date-text",183,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported  VSC Supplier committed date"," date-text",184,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Imported  VSC Actual receipt date"," date-text",185,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual imported VSC","wide-text",186,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Special relay planned receipt date"," date-text",187,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Special relay requested receipt date"," date-text",188,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Special relay Supplier committed date"," date-text",189,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Special relay Actual receipt date"," date-text",190,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Special relay","wide-text",191,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("CT / PT Planned Receipt"," date-text",192,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT / PT requested receipt date"," date-text",193,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT / PT Supplier committed date"," date-text",194,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("CT / PT Actual Receipt"," date-text",195,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual CT/PT","wide-text",196,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Relay Planned Receipt"," date-text",197,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Relay Requested receipt date"," date-text",198,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Relay Supplier committed date"," date-text",199,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Relay Actual Receipt"," date-text",200,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Relay","wide-text",201,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Breaker  Planned receipt"," date-text",202,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Breaker Requested receipt date"," date-text",203,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Breaker Supplier committed date"," date-text",204,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Breaker Actual receipt"," date-text",205,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Breaker","wide-text",206,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Jumper Planned Receipt"," date-text",207,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Jumper Requested receipt date"," date-text",208,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Jumper Supplier committeddate"," date-text",209,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Jumper Actual Receipt"," date-text",210,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Jumper","wide-text",211,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Metering Box Planned Receipt"," date-text",212,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Metering Box requested receipt date"," date-text",213,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Metering Box supplier committed date"," date-text",214,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Metering Box Actual Receipt"," date-text",215,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Jumper","wide-text",216,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("SA Planned receipt date"," date-text",217,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SA Requested receipt date"," date-text",218,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SA Supplier committed date"," date-text",219,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("SA  receipt date- Actual"," date-text",220,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual SA","wide-text",221,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Boughtout fabrication Planned receipt date"," date-text",222,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Boughtout fabrication requested receipt date"," date-text",223,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Boughtout fabrication supplier committed date"," date-text",224,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Boughtout fabrication Actual receipt date"," date-text",225,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for boughtout fabrication","wide-text",226,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Inhouse fabrication Planned receipt date"," date-text",227,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Inhouse fabrication requested receipt date"," date-text",228,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Inhouse fabrication supplier committed date"," date-text",229,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Inhouse fabrication Actual receipt date"," date-text",230,"auto",7,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for Inhouse fabrication","wide-text",231,"auto",7,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Material issue to line- Planned date"," date-text",232,"auto",8,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Material issue to line- Requested line loading date"," date-text",233,"auto",8,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Material issue to line- Actual date"," date-text",234,"auto",8,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual material issue to line","wide-text",235,"auto",8,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Loose material Issue to dispatch- Planned date"," date-text",236,"auto",8,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Loose material Issue to dispatch- Requested  date"," date-text",237,"auto",8,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Loose material Issue to dispatch- Actual date"," date-text",238,"auto",8,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual loose material issue to dispatch","wide-text",239,"auto",8,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Mechanical sticker date- Planned"," date-text",240,"auto",9,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Mechanical sticker  Requested  date"," date-text",241,"auto",9,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Mechanical sticker Actual date"," date-text",242,"auto",9,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual mechanical sticker ","wide-text",243,"auto",9,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Mechanical /Electrical testing planned date"," date-text",244,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Mechanical/Electrical testing Requested  date"," date-text",245,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Mechanical/Electrical testing Actual date"," date-text",246,"auto",10,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual mechanical/electrical testing","wide-text",247,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("FAT Planned date"," date-text",248,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("FAT Requested date"," date-text",249,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("FAT Actual date"," date-text",250,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual FAT","wide-text",251,"auto",10,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Green sticker Planned date","",252,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Green sticker Requested date"," date-text",253,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Green sticker Actual date"," date-text",254,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Green sticker","wide-text",255,"auto",10,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Dispatch Planned date from plant"," date-text",256,"auto",11,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Dispatch Requested  date from plant"," date-text",257,"auto",11,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Dispatch date from plant - Actual"," date-text",258,"auto",11,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Remark delay/early for actual Dispatch date","wide-text",259,"auto",11,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Partial Dispatch Qty","",260,"auto",11,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("Earthling truck actual dispatch date","",261,"auto",11,0));
    
  //   _tmpHeadRows.push(new TblHeadCellDef("Spares actual dispatch date","",262,"auto",11,0));
  //   _tmpHeadRows.push(new TblHeadCellDef("ROTD Date"," date-text",263,"auto",6,0));
        

    return _tmpHeadRows;
  }

  public trackHeaderBy(index, item){
    return item.cellIndex;
  }
  public trackSubSOBy(index, item){
    return index;
  }
}

export class showTblModule {
  constructor() {

  }
  public showMarketing: boolean = true;
  public showPM: boolean = true;
  public showSCM: boolean = true;
  public showEngg: boolean = true;
  public showPO: boolean = true;
  public showPlanning: boolean = true;
  public showMatReceipt: boolean = true;
  public showStore: boolean = true;
  public showProduction: boolean = true;
  public showQuality: boolean = true;
  public showLogistics: boolean = true;
}